export const MONTHS = {
  1: "Siječanj",
  2: "Veljača",
  3: "Ožujak",
  4: "Travanj",
  5: "Svibanj",
  6: "Lipanj",
  7: "Srpanj",
  8: "Kolovoz",
  9: "Rujan",
  10: "Listopad",
  11: "Studeni",
  12: "Prosinac",
};
